// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.za0zeg9CVGQX1G1sIKD8{align-items:center;gap:8px;height:32px;display:flex}.fVQPZaPYPoI9twWFhJIQ{color:var(--content-primary-primary);text-overflow:ellipsis;white-space:pre;max-width:120px;font-size:13px;font-weight:400;line-height:normal;overflow:hidden}.KuiHiZHsrzM_VKtLIdyP{align-items:center;height:100%;display:flex;position:relative}.KuiHiZHsrzM_VKtLIdyP .yvm2yuxFMw4EEQCeomAZ{border:1.5px var(--background-primary-inverted-primary)solid;border-radius:50%;display:block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `za0zeg9CVGQX1G1sIKD8`,
	"selectedLabel": `fVQPZaPYPoI9twWFhJIQ`,
	"avatars": `KuiHiZHsrzM_VKtLIdyP`,
	"avatar": `yvm2yuxFMw4EEQCeomAZ`
};
export default ___CSS_LOADER_EXPORT___;
